import { useEffect, useState } from 'react';

import { VaultService } from 'utils/storage';

const vaultService = new VaultService();

export const useGetUser = () => {
	const [user, setUser] = useState(
		localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null
	);
	const [token, setToken] = useState<string | null>(
		localStorage.getItem('user') ? vaultService.getItem('token') : null
	);

	useEffect(() => {
		const handleStorageChange = () => {
			const updatedUserValue = localStorage.getItem('user')
				? JSON.parse(localStorage.getItem('user') || '')
				: null;
			const updatedTokenValue = vaultService.getItem('token');

			if (updatedUserValue !== user) {
				setUser(updatedUserValue);
			}

			if (updatedTokenValue !== token) {
				setToken(updatedTokenValue);
			}
		};

		window.addEventListener('storage', handleStorageChange);

		return () => {
			window.removeEventListener('storage', handleStorageChange);
		};
	}, [user, token]);

	return {
		user,
		token,
		setUser,
	};
};
